import { useMemo } from 'react';
import { EnterpriseBusinessUnit } from 'models/Enterprises';
import { useTranslation } from 'react-i18next';
import { getSortComparator, removeLINK, sortByName } from 'utils';

export default function useBusinessUnits(
  businessUnits: EnterpriseBusinessUnit[] = [],
) {
  const { t } = useTranslation();

  const sortedBusinessUnits = useMemo(
    () => sortByName(businessUnits),
    [businessUnits],
  );

  const businessUnitsOptions = useMemo(
    () =>
      businessUnits
        .map(({ _id, name }) => ({
          value: _id,
          label: t(removeLINK(name)),
        }))
        .sort((a, b) =>
          getSortComparator(a.label.toLowerCase(), b.label.toLowerCase()),
        ),
    [businessUnits, t],
  );

  return { sortedBusinessUnits, businessUnitsOptions };
}
